(function() {
  'use strict';
  
  angular
    .module('app.shell')
    .factory('shell', shell);
      
  shell.$inject = ['$log', '$rootScope', '$state', '$transitions', 'metrics', 'viewSyncService'];
    
  function shell($log, $rootScope, $state, $transitions, metrics, viewSyncService) {

    $log = $log.getInstance('shell');
    
    init();

    var persist = {
      action: false,
      back: false,
      menu: false,
      search: false,
      sidebar: false,
      theme: false,
      toolbar: false,
      userMenu: false
    };

    var service = {
      action: null,
      back: {
        state: null,
        stateParams: null
      },
      clearAction: clearAction,
      clearSearch: clearSearch,
      hideSearch: hideSearch,
      menu: {
        items: [],
        show: false,
        title: null
      },
      search: {
        callback: false,
        phrase: '',
        show: false
      },
      searchPhraseChanged: searchPhraseChanged,
      setAction: setAction,
      setBack: setBack,
      setMenu: setMenu,
      setSearch: setSearch,
      setTheme: setTheme,
      setTitle: setTitle,
      setToolbar: setToolbar,
      setUserMenu: setUserMenu,
      showSearch: showSearch,
      showSidebar: showSidebar,
      sidebar: {
        show: false,
        url: null,
        vm: null
      },
      theme: null,
      title: '',
      toolbar: {
        items: [],
      },
      userMenu: {
        items: [],
        show: false
      },
      viewSync: viewSyncService
    };
    return service;
    
    function init() {
      $transitions.onSuccess({}, stateChangeReset);
    }

    function clearAction() {
      service.action = null;
    }
    
    function clearSearch() {
      service.search.phrase = '';
      searchPhraseChanged();
    }
    
    function hideSearch() {
      clearSearch();
      service.search.show = false;
    }
    
    function stateChangeReset(transition) {
      var state = transition.to();
      var stateName = state.name;
      service.action = null;
      _setIfNotPersist('back', {
        state: null,
        stateParams: null
      }, stateName);
      _setIfNotPersist('menu', {
        items: [],
        show: false
      }, stateName);
      _setIfNotPersist('search', {
        callback: false,
        phrase: '',
        show: false
      }, stateName);
      _setIfNotPersist('sidebar', {
        show: false,
        url: null,
        vm: null
      }, stateName);
      _setIfNotPersist('theme', state.theme || '', stateName);
      _setIfNotPersist('title', state.title || '', stateName);
      _setIfNotPersist('toolbar', {
        items: []  
      }, stateName);
      _setIfNotPersist('userMenu', {
        items: [],
        show: false  
      }, stateName);
    }
    
    function searchPhraseChanged() {
      if (!angular.isFunction(service.search.callback))
        return;
      service.search.callback(service.search.phrase);
    }

    function setAction(action) {
      service.action = action;
    }
    
    function setBack(state, stateParams, options) {
      _set('back', {
        state: state,
        stateParams: stateParams
      }, options);
    }
    
    function setMenu(menuItems, title, options) {
      _set('menu', {
        items: menuItems,
        show: true,
        title: title || null
      }, options);
    }
    
    function setSearch(searchCallback, options) {
      _set('search', { callback: searchCallback }, options);
    }

    // function setSidebar(sidebarItems, options) {
    //   service.sidebar.items = sidebarItems;
    //   service.sidebar.show = true;
    // }

    function setTheme(theme, options) {
      _set('theme', theme, options);
    }
    
    function setTitle(title, options) {
      _set('title', title, options);
    }

    function setToolbar(toolbarItems, options) {
      _set('toolbar', { items: toolbarItems }, options);
    }
    
    function showSearch(options) {
      service.search.show = true;
      metrics.log('search show')
    }

    function showSidebar(url, vm, options) {
      _set('sidebar', {
        show: true,
        url: url,
        vm: vm || null
      }, options); 
    }

    function setUserMenu(menuItems, options) {
      _set('userMenu', {
        show: true,
        items: menuItems
      }, options);
    }

    function _isChildState(currentStateName, parentStateName) {
      return parentStateName 
        && currentStateName.indexOf(parentStateName) === 0
        && currentStateName.length >= parentStateName.length;
    }

    function _set(key, value, options) {
      options = options || {};
      persist[key] = options.persist || persist[key] || false;
      service[key] = value;
    }

    function _setIfNotPersist(key, value, currentStateName) {
      if (_isChildState(currentStateName, persist[key]))
        return;
      persist[key] = false;
      service[key] = value;
    }
    
  }
  
})();